import React from "react";

const Title = ({ label }) => (
  <section className="bg-gray-100 px-4 py-8 dark:bg-gray-900">
    <h2 className="text-2xl text-center font-medium text-primary-900 dark:text-primary-100">{label}</h2>
  </section>
);

export default Title;
